import React from "react";
import { Breadcrumb } from "../../components/ui";
import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useGetVenueByIdQuery } from "../../store/services/venues";
import { VenueForm } from "../../components/Forms/VenueForm";
import { useTenantScope } from "../../hooks/useTenantScope";
import { BenefitsMetricsTenantScopeHeader } from "../Reporting/components/BenefitsMetricsWidgets";

export const EditVenue = () => {
  const { venueId } = useParams();
  const tenantScope = useTenantScope();
  const { data, isLoading, refetch } = useGetVenueByIdQuery(venueId || "");

  return (
    <div className="grid">
      <Breadcrumb items={[{ label: "Venues", to: "/venues" }, { label: "Editar venue" }]} />
      <div className="col-12">
        <div className="p-card p-4">
          <div className="flex align-items-center justify-content-center mb-2 pb-3 border-bottom-1 surface-border">
            <h2 className="text-2xl font-semibold text-900 m-0">Editar Venue</h2>
          </div>
          <BenefitsMetricsTenantScopeHeader tenantId={tenantScope.tenantId} />
          {isLoading ? (
            <div className="flex flex-column justify-content-center align-items-center p-5">
              <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" />
              <p className="text-600 mt-3 m-0">Cargando contenido</p>
            </div>
          ) : (
            <VenueForm venueData={data} refetchVenueData={refetch} />
          )}
        </div>
      </div>
    </div>
  );
};
